module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"pressKeyToAction":"{press} {key} {to} {action}","press":"Press","to":"to"},"pt":{"pressKeyToAction":"{press} {key} {to} {action}","press":"Pressione","to":"para"}}')
  delete Component.options._Ctor
}
